import React, { Component } from 'react';
import Site, {SiteModifier_} from '../utils/Site';

import {
  Link
} from 'react-router-dom';

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import FadeIn from '../components/FadeIn'

class COMPONENT extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;
		//console.log('entry',entry);
		return (
			<FadeIn>
			<div className="Template  Template--grid">

					<div className="Template-categories">
						Categories
					</div>

					<div className="Template-body">

						<div className="Template-locations">
							<Grid modifiers={['4']}>

								<div className="Grid-item">

									<Item>
										<Link to={'#'}>

											<div className="Item-media">
												<Image ratio={202/166} small={'https://static.photocdn.pt/images/articles/2017_1/iStock-545347988.jpg'} />
											</div>

											<div className="Item-head">
												<h2 className="Item-title">Item-title</h2>
												<h4 className="Item-subTitle">Item-subTitle</h4>
											</div>

										</Link>
									</Item>

								</div>

								<div className="Grid-item">

									<Item>
										<Link to={'#'}>

											<div className="Item-media">
												<Image ratio={202/166} small={'https://static.photocdn.pt/images/articles/2017_1/iStock-545347988.jpg'} />
											</div>

											<div className="Item-head">
												<h2 className="Item-title">Item-title</h2>
												<h4 className="Item-subTitle">Item-subTitle</h4>
											</div>

										</Link>
									</Item>

								</div>

								<div className="Grid-item">

									<Item>
										<Link to={'#'}>

											<div className="Item-media">
												<Image ratio={202/166} small={'https://static.photocdn.pt/images/articles/2017_1/iStock-545347988.jpg'} />
											</div>

											<div className="Item-head">
												<h2 className="Item-title">Item-title</h2>
												<h4 className="Item-subTitle">Item-subTitle</h4>
											</div>

										</Link>
									</Item>

								</div>

								<div className="Grid-item">

									<Item>
										<Link to={'#'}>

											<div className="Item-media">
												<Image ratio={202/166} small={'https://static.photocdn.pt/images/articles/2017_1/iStock-545347988.jpg'} />
											</div>

											<div className="Item-head">
												<h2 className="Item-title">Item-title</h2>
												<h4 className="Item-subTitle">Item-subTitle</h4>
											</div>

										</Link>
									</Item>

								</div>

							</Grid>
						</div>

					</div>

					<div className="Template-pagination">
						Template-pagination
					</div>

			</div>
			</FadeIn>
		);

	}
}

export default COMPONENT;



// WEBPACK FOOTER //
// ./src/js/templates/Grid.js